/**
 * Convert prefix to domain titles
 * @param {string} prefix - Prefix to convert
 * @returns {string} - Domain title
 */
function prefixToDomainTitles(prefix) {
	// Detect legacy mode based on dashboard selection
	const selectedDashboard = jQuery('.dashboard-selection').val();
	const isLegacyMode = selectedDashboard !== 'CRFS';

	const year = (typeof WebAssessmentCharts !== 'undefined' && WebAssessmentCharts.assessmentYear)
		? parseInt(WebAssessmentCharts.assessmentYear, 10)
		: null;
	const sdmTitle = (year && year >= 2026) ? 'Software Development Standardization Management' : 'Software Development Management';

	const commonPrefixMap = {
		'GOV': 'Governance',
		'THR': 'Threat Management',
		'POL': 'Security Policy Management',
		'PM': 'Project Management',
		'CHM': 'Exception Management',
		'MET': 'Metrics Management',
		'AUD': 'Audit Management',
		'TPM': 'Third Party Management',
		'RR': 'Risk Reporting',
		'PER': 'Personnel Management',
		'BCP': 'Business Continuity',
		'IM': 'Incident Management',
		'AID': 'Asset Inventory',
		'SID': 'Software Inventory',
		'AC': 'Application Control',
		'PAT': 'Patch Management',
		'VM': 'Vulnerability Management',
		'CM': 'Configuration Management',
		'END': 'Endpoint Protection',
		'REM': 'Removable Media Protection',
		'BAC': 'Backup and Recovery',
		'LOG': 'Log Management',
		'FIM': 'File Integrity Management',
		'IDM': 'Identity Management',
		'ID': 'Identity Management',
		'DI': 'Data Inventory Management',
		'AM': 'Access Management',
		'PAM': 'Privileged Account Management',
		'NDM': 'Network Device Management',
		'BD': 'Boundary Filtering',
		'RA': 'Remote Access',
		'WF': 'Web Filtering',
		'EF': 'Email Filtering',
		'NSC': 'Network Segmentation',
		'WIR': 'Wireless',
		'SDS': 'Software Development',
		'SCA': 'Static Code Analysis',
		'PRG': 'Program Management',
		'SAF': 'Safeguard Selection Management',
		'AST': 'Asset Management',
		'IMP': 'Safeguard Implementation Management',
		'VAL': 'Safeguard Validation Management',
		'TPR': 'Third-Party Risk Management',
		'COM': 'Risk Communication Management',
		'RES': 'Resilience Management',
		'AI': 'Artificial Intelligence Management',
		'SYS': 'System Protection Management',
		'SW': 'Software Management',
		'CFG': 'Configuration Management',
		'VUL': 'Vulnerability Management',
		'PNA': 'Perimeter Network Access Management',
		'INA': 'Internal Network Access Management',
		'CSP': 'Cloud Service Provider Management',
		'EM': 'Email Management',
		'SDM': sdmTitle,
		'SDV': 'Software Development Vulnerability Management',
		'SDO': 'Software Development Operations Management'
	};

	const modernPrefixMap = {
		...commonPrefixMap,
		'EDU': 'Education Management',
		'PHY': 'Physical Security Management',
		'PRV': 'Privacy Management',
		'MDM': 'Mobile Device Management',
		'DTA': 'Data Inventory Management',
	};

	const legacyPrefixMap = {
		...commonPrefixMap,
		'EDU': 'Education and Awareness',
		'PHY': 'Physical Security',
		'PRV': 'Data Privacy',
		'MDM': 'Mobile Device Protection',
		'DTA': 'Data Inventory Management',
	};

	const prefixMap = isLegacyMode ? legacyPrefixMap : modernPrefixMap;
	return prefixMap[prefix] || prefix; // Return the full title or the prefix itself if not found
}

// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
	module.exports = prefixToDomainTitles;
} else if (typeof window !== 'undefined') {
	window.prefixToDomainTitles = prefixToDomainTitles;
}
